import Dragon from '../components/Dragon';
import SectionHeader from '../components/SectionHeader';
import { skillCategories } from '../data/skills';
import styles from './Skills.module.css';

function Skills() {
  return (
    <div className={styles.skills}>
      <Dragon />
      <SectionHeader 
        title="Tech Stack" 
        subtitle="Technologies and tools I work with"
      />
      
      {skillCategories.map((category, catIndex) => (
        <div key={catIndex} className={styles.categorySection}>
          <h3 className={styles.categoryTitle}>{category.category}</h3>
          <div className={styles.iconGrid}>
            {category.skills.map((skill, index) => {
              const Icon = skill.icon;
              return (
                <div 
                  key={index} 
                  className={styles.skillItem}
                  title={skill.name}
                >
                  <Icon size={48} className={styles.techIcon} />
                  <span className={styles.skillName}>{skill.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}

      <p className={styles.footer}>
        Always open to learning new technologies and expanding my skill set.
      </p>
    </div>
  );
}

export default Skills;
